import colors from "core/resources/theme/colors";
import { Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { MdOutlineDone } from "react-icons/md";
import PrimaryButton from "components/Button/PrimaryButton";
import { Tag } from "@chakra-ui/react";

interface TagModalCadastroIncompletoProps {
  labelTop: string;
  labelBot: string;
  isCheck: boolean;
  handleCompletar: () => any
}

export function TagModalCadastroIncompleto({
  labelTop,
  labelBot,
  isCheck,
  
  handleCompletar
}: TagModalCadastroIncompletoProps) {
  
  return (
    <Tag
      h={20}
      bg="none"
      border={`solid  ${isCheck ? colors.gray : colors.green} 1px`}
      rounded={15}
      justifyContent="space-between"
      p={4}
    >
      <Flex flexDirection="column" gap={1}>
        <Text fontSize="16px" fontWeight="bold">
          {labelTop}
        </Text>
        <Text>{labelBot}</Text>
      </Flex>

      {isCheck ? (
        <PrimaryButton onClick={handleCompletar}>Completar</PrimaryButton>
      ) : (
        <Flex
          bg={colors.green100}
          minW="50px"
          minH="50px"
          maxH="50px"
          maxW="50px"
          rounded="100%"
          border={`solid ${colors.green} 1px`}
          justifyContent="center"
          alignItems="center"
        >
          <MdOutlineDone size={30} color={colors.green} />
        </Flex>
      )}
    </Tag>
  );
}
